import React from 'react';
import { Home, RefreshCw, AlertTriangle } from 'lucide-react';

const ErrorFallback = ({ error, resetError }) => {
  const isChunkError = error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('chunk');

  return (
    <>
      <div className="bg-[#111] border-b border-white/[0.06]">
        <div className="max-w-[1600px] mx-auto px-4 2xl:px-8 py-10" />
      </div>
      <div className="bg-[#f5f5f5] min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center max-w-lg w-full">
          <div className="w-16 h-16 bg-red-50 flex items-center justify-center mx-auto mb-6">
            <AlertTriangle size={28} className="text-red-500" />
          </div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 tracking-tight">
            {isChunkError ? 'Update available' : 'Something went wrong'}
          </h1>
          <p className="text-sm text-gray-500 mb-8 leading-relaxed max-w-sm mx-auto">
            {isChunkError
              ? 'A new version of JD Store is available. Please refresh to continue.'
              : "We hit an unexpected error. Try refreshing or return to the homepage."}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={() => { resetError?.(); window.location.reload(); }}
              className="flex items-center gap-2 px-7 py-3 bg-primary text-white text-sm font-semibold border-none cursor-pointer hover:bg-primary-dark transition-colors uppercase tracking-wide"
            >
              <RefreshCw size={14} /> Refresh Page
            </button>
            <button
              onClick={() => { resetError?.(); window.location.href = '/'; }}
              className="flex items-center gap-2 px-7 py-3 bg-white text-gray-600 text-sm font-medium border border-gray-200 hover:border-gray-400 hover:text-gray-900 transition-colors cursor-pointer uppercase tracking-wide"
            >
              <Home size={14} /> Go Home
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    
    // Handle chunk loading errors specifically
    if (error.name === 'ChunkLoadError' || error.message?.includes('Loading chunk')) {
      console.log('Chunk loading error detected, will show refresh prompt');
    }
  }

  resetError = () => {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error} resetError={this.resetError} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;